/* eslint-disable */
import { useContext } from 'react';
import { AuthContext } from '../../Contexts/AuthContext';
import { splitColon, formatString } from '../../Utils/stringIncludes';
import { MODULE_NAMES } from '../../Constants/modules';

const permissionPathOverrides = {
    'home:dashboard': ['Home', 'Dashboard'],
    'home:dashboard:account-based-report': ['Home', 'Dashboard', 'Account Based Report View'],
    'home:dashboard:account-based-filter': ['Home', 'Dashboard', 'Senior Manager Filter View'],
    'home:dashboard:architect-report': ['Home', 'Dashboard', 'Architect Dashboard View'],
    'home:dashboard:architect-filter': ['Home', 'Dashboard', 'Architect Filter View'],
    'home:dashboard:architect-technology': ['Home', 'Dashboard', 'Architect Technology View'],
    'home:dashboard:architect-effort-deviation': ['Home', 'Dashboard', 'Architect Effort Deviation View'],
    'home:dashboard:architect-utilization': ['Home', 'Dashboard', 'Architect Utilization View'],
    'home:dashboard:architect-ru-unit': ['Home', 'Dashboard', 'Architect RU Unit View'],
    'home:dashboard:pm-report': ['Home', 'Dashboard', 'PM Dashboard View'],
    'home:dashboard:pm-filter': ['Home', 'Dashboard', 'PM Filter View'],
    'home:dashboard:pm-csat': ['Home', 'Dashboard', 'PM CSAT View'],
    'home:dashboard:pm-quality-audit': ['Home', 'Dashboard', 'PM Quality Audit View'],
    'home:dashboard:pm-pmo-audit': ['Home', 'Dashboard', 'PM PMO Audit View'],
    'home:dashboard:pm-ru-unit': ['Home', 'Dashboard', 'PM RU Unit View'],
    'masters:performance:declare-performance-period': ['Masters', 'Performance', 'Declare performance period'],
    'masters:performance:declare-remarks': ['Masters', 'Performance', 'Declare source & remark'],
    'masters:deal-transition:deal-status': ['Masters', 'Deal transition', 'Deal Status'],
    'masters:deal-transition:deal-role': ['Masters', 'Deal transition', 'Deal Role'],
    'masters:deal-transition:parameters': ['Masters', 'Deal transition', 'Parameters'],
    'masters:deal-transition:efforts': ['Masters', 'Deal transition', 'Efforts'],
    'masters:deal-transition:cost-master': ['Masters', 'Deal transition', 'Cost Master'],
    'masters:staff-aug-status:requirement-status': ['Masters', 'StaffAug status', 'Requirement Status'],
    'masters:staff-aug-status:client-interview-status': ['Masters', 'StaffAug status', 'Client Interview Status'],
    'masters:staff-aug-status:lost-dropped-status': ['Masters', 'StaffAug status', 'Lost/ Dropped Status'],
    'masters:staff-aug-status:geography': ['Masters', 'StaffAug status', 'Geography'],
    'masters:configuration:cloud-provider': ['Masters', 'Configuration', 'Cloud Provider'],
    'masters:configuration:allocation-stakeholders': ['Masters', 'Configuration', 'Allocation Stakeholders'],
    'masters:configuration:department-list': ['Masters', 'Configuration', 'Department List'],
    'masters:configuration:employee-experience': ['Masters', 'Configuration', 'Employee Experience'],
    'certifications:overview': ['Certifications', 'Certifications Overview'],
    'users:user-management': ['Users', 'User Management'],
    'certifications:map': ['Certifications', 'Certifications Mapping'],
    'skills:skill-mapping': ['Skills', 'Skill Mapping'],
    'configuration:manage-kpi': ['Configurations', 'Manage KPI'],
    'configuration:data-upload:effort-upload': ['Configurations', 'Data Upload', 'Effort Upload'],
    'configuration:data-upload:leave-upload': ['Configurations', 'Data Upload', 'Leave Upload'],
    'configuration:data-upload:file-upload': ['Configurations', 'Data Upload', 'File Upload'],
    'configuration:date-configuration': ['Configurations', 'Date Config'],
    'general-config:search': ['GeneralConfig', 'Search'],
    'employee-profile:onboarding': ['EmployeeProfile', 'Onboarding'],
    'employee-profile:achievements': ['EmployeeProfile', 'Skills, Awards and Certifications'],
    'employee-profile:trainings-and-assessments': ['EmployeeProfile', 'Trainings and Assessments'],
    'employee-profile:projects': ['EmployeeProfile', 'Projects'],
    'employee-profile:performance': ['EmployeeProfile', 'Performance'],
    'deal-transition:dashboard': ['DealTransition', 'Dashboard'],
    'deal-transition:deal-detail-commercials': ['DealTransition', 'Deal Detail-Commercials'],
    'deal-transition:deal-effort-estimation': ['DealTransition', 'Effort Estimation'],
    'deal-transition:staffing-projections': ['DealTransition', 'Staffing Projections'],
    'deal-transition:commercial-projections': ['DealTransition', 'Commercial Projections'],
    'deal-transition:custom-workflow': ['DealTransition', 'Custom Workflow'],
    'deal-transition:deal-sla-override': ['DealTransition', 'Deal SLA override'],
    'deal-transition:deal-assign': ['DealTransition', 'Deal-Assign'],
    'deal-transition:deal-status-change': ['DealTransition', 'Deal-Status Change'],
    'deal-transition:revenue': ['DealTransition', 'Revenue'],
    'deal-transition:deal-approval:deal-effort-approval': ['DealTransition', 'Deal Approval', 'Deal Effort Approval'],
    'deal-transition:deal-approval:deal-financial-approval': ['DealTransition', 'Deal Approval', 'Deal Financial Approval'],
    'finance:milestone': ['Finance', 'Milestone', 'Milestone Section'],
    'finance:milestone:po-number-view': ['Finance', 'Milestone', 'PO Number'],
    'finance:milestone:po-link-view': ['Finance', 'Milestone', 'PO Link'],
    'finance:milestone:replanned-due-date-view': ['Finance', 'Milestone', 'Replanned Due Date'],
    'finance:milestone:milestone-invoice-amount-view': ['Finance', 'Milestone', 'Milestone Invoice Amount'],
    'finance:milestone:milestone-amount-view': ['Finance', 'Milestone', 'Milestone Amount'],
    'finance:milestone:milestone-received-date-view': ['Finance', 'Milestone', 'Milestone Received Date'],
    'finance:milestone:milestone-remarks-view': ['Finance', 'Milestone', 'Milestone Remarks'],
    'finance:milestone:collection-amount-view': ['Finance', 'Milestone', 'Collection Amount'],
    'finance:milestone:collection-date-view': ['Finance', 'Milestone', 'Collection Date'],
    'finance:employee-cost-details': ['Finance', 'Employee Cost Details'],
    'finance:client-details': ['Finance', 'Client Details'],
    'finance:zoho-customer-details': ['Finance', 'Zoho Client Details'],
    'finance:po-details': ['Finance', 'Po Details'],
    'finance:zoho-invoice-details': ['Finance', 'Zoho Invoice Details'],
    'mis:collection-report': ['MIS', 'Collection Report'],
    'mis:reseller-report': ['MIS', 'Reseller Report'],
    'mis:billing-report': null,
    'mis:billing-report-amount-addition': null,
    'mis:billing-report-approval-history': null,
    'mis:delivery-utilization-report': ['MIS', 'Delivery Utilization'],
    'mis:health-check:pmo': ['MIS', 'Health Check', 'PMO'],
    'mis:health-check:architecture': ['MIS', 'Health Check', 'Architecture'],
    'mis:employee-mis': ['MIS', 'Employee MIS'],
    'mis:employee-utilization-report': ['MIS', 'Employee Utilization'],
    'mis:activity-report': ['MIS', 'Activity Report'],
    'mis:milestone-mis': ['MIS', 'Milestone MIS'],
    'masters:configuration:region-list': ['Masters', 'Configuration', 'Region List'],
    'masters:configuration:invoice-type': ['Masters', 'Configuration', 'Invoice Type'],
    'masters:configuration:country-list': ['Masters', 'Configuration', 'Country List'],
    'masters:configuration:delivery-methodology': ['Masters', 'Configuration', 'Delivery Methodology'],
    'mis:edr-employee-effort': ['MIS', 'EDR Employee Effort'],
    'mis:edr-activity-report': ['MIS', 'EDR Activity Report'],
    'mis:edr_activity_report': ['MIS', 'EDR Activity Report'],
    'mis:staff-augmentation-report': ['MIS', 'Staff Aug Report'],
    'mis:revenue-recognition': ['MIS', 'Revenue Recognition'],
    'mis:revenue-mis': ['MIS', 'Revenue MIS'],
    'mis:csat-history': ['MIS', 'CSAT History'],
    'mis:csat-customer-details': ['MIS', 'CSAT Customer Details'],
    'mis:ai-tool-mis': ['MIS', 'AI Tool MIS'],
    'mis:ird': ['MIS', 'IRD'],
    'mis:allocation-mis': ['MIS', 'Allocation MIS'],
    'mis:po-mis': ['MIS', 'PO MIS'],
    'mis:edr-project-effort': ['MIS', 'EDR Project Effort'],
    'mis:project-employee-cost': ['MIS', 'Project Employee Cost Report'],
    'mis:offering-wise-report': ['MIS', 'Offering Wise Report'],
    'mis:project-cost-report': ['MIS', 'Project Cost Report'],
    'mis:timesheet-mis': ['MIS', 'Time Sheet MIS'],
    'mis:time-sheet-mis-list-view': ['MIS', 'Time Sheet MIS', 'List View'],
    'mis:time-sheet-mis-calendar-view-employee-wise': ['MIS', 'Time Sheet MIS', 'Calendar View Employee Wise'],
    'mis:time-sheet-mis-calendar-view-activity-wise': ['MIS', 'Time Sheet MIS', 'Calendar View Activity Wise'],
    'mis:accrued-revenue-report': ['MIS', 'Accrued Revenue Report'],
    'mis:project-allocation': ['MIS', 'Project Allocation %'],
    'mis:role-ratio-report': ['MIS', 'Role Ratio Report'],
    'mis:projectwise-salary-report': ['MIS', 'Project Wise Salary Report'],
    'mis:project-wise-expense-report': ['MIS', 'Project Wise Expense Report'],
    'mis:milestone-report': ['MIS', 'Milestone Report'],
    'delivery:staffing-request': ['Delivery', 'Staffing Request', 'Staffing Request View/Edit'],
    'delivery:staffing-request-approval': ['Delivery', 'Staffing Request', 'Staffing Request Approval'],
    'delivery:project-details:customer-type': ['Delivery', 'Project Overview', 'Project Details', 'Customer Type'],
    'delivery:project-details:vg/-nvg': ['Delivery', 'Project Overview', 'Project Details', 'VG / NVG'],
    'delivery:project-details:effort-logging': ['Delivery', 'Project Overview', 'Project Details', 'Effort Logging'],
    'delivery:project-details:jira-project-id': ['Delivery', 'Project Overview', 'Project Details', 'Jira Project Id'],
    'delivery:project-dl': ['Delivery', 'Project Overview', 'Project Details', 'Project DL'],
    'delivery:project-details:utilization': ['Delivery', 'Project Overview', 'Project Details', 'Project Billability'],
    'delivery:add-projects': ['Delivery', 'Add Projects'],
    'delivery:project-user-access': ['Delivery', 'Project Overview', 'Project – User Access'],
    'delivery:project-manager-access': ['Delivery', 'Project Overview', 'Project – Manager Access'],
    'delivery:project-overview:project-details': ['Delivery', 'Project Overview', 'Project Details', 'Project Details View'],
    'delivery:project-overview:project-details-edit': ['Delivery', 'Project Overview', 'Project Details', 'Project Details Fields Edit'],
    'delivery:project-overview:project-manager-details-edit': ['Delivery', 'Project Overview', 'Project Details', 'Project Manager Details Edit'],
    'delivery:resource-loading-plan': ['Delivery', 'Project Overview', 'Resource Loading Plan', 'Resource Loading Plan Details'],
    'delivery:resource-loading-approval-history': ['Delivery', 'Project Overview', 'Resource Loading Plan', 'Resource Loading Approval History'],
    'delivery:project-overview:status-history-approval': ['Delivery', 'Project Overview', 'Status Change Request'],
    'delivery:project-info-lookup': ['Delivery', 'Project Info Lookup'],
    'delivery:project-overview:resource-allocation-count': ['Delivery', 'Project Overview', 'Resource Allocation Count'],
    'delivery:project-overview:resource-allocation-details': ['Delivery', 'Project Overview', 'Resource Allocation Details'],
    // Group them into a uniform structure under 'Projects'
    'project:change-request': ['Projects', 'Change Request', 'Change Request Details'],
    'project:change-request:approve-reject-request': ['Projects', 'Change Request', 'Approve/Reject Request'],
    'delivery:project-overview:timeline-change-request': ['Projects', 'Timeline'],
    // 'project:time-sheet-report': ['Projects', 'Time Sheet Report'],
    'project:time-sheet-report-list-view': ['Projects', 'Time Sheet Report', 'List View'],
    'project:time-sheet-report-calendar-view': ['Projects', 'Time Sheet Report', 'Calendar View'],

    'project:file-upload': null,
    'project:file-upload:redmine-data': ['Projects', 'File Upload', 'Upload Redmine Data'],
    'project:file-upload:leave-data': ['Projects', 'File Upload', 'Upload Leave Data'],
    'project:file-upload:holiday-data': ['Projects', 'File Upload', 'Upload Holiday Data'],
    'project:file-upload:leave-test': ['Projects', 'File Upload', 'Upload Leave Data for Testing'],
    'project:file-upload:salary-data': ['Projects', 'File Upload', 'Upload Salary Data'],
    'project:file-upload:project-expense': ['Projects', 'File Upload', 'Upload Project Expense'],
    'project:file-upload:jira-effort-data': ['Projects', 'File Upload', 'Upload Jira Effort Data'],
    'project:budget-change-request:approve': ['Delivery', 'Project Overview', 'Budget change request', 'Approve'],
    'project:budget-change-request:efforts': ['Delivery', 'Project Overview', 'Budget change request', 'Efforts'],
    'project:budget-change-request:cost': ['Delivery', 'Project Overview', 'Budget change request', 'Cost'],
    'resource:resource-management': ['Resource', 'Resource Management'],
    'resource:tbh-employee-management': ['Resource', 'TBH Employee Management'],
    'staff-augmentation:requirement-status': ['StaffAugmentation', 'Requirement'],
    'staff-augmentation:project-resourcing': ['StaffAugmentation', 'Project Resourcing'],
    'staff-augmentation:clone-requirement': ['StaffAugmentation', 'Clone Requirement'],
    'staff-augmentation:resume-generation:view-resume-details': ['StaffAugmentation', 'Resume Generation', 'View Resume Details'],
    'staff-augmentation:resume-generation:generate-resume': ['StaffAugmentation', 'Resume Generation', 'Generate Resume'],
    'staff-augmentation:resume-generation:upload-resume': ['StaffAugmentation', 'Resume Generation', 'Upload Resume'],
    'staff-augmentation:resume-generation:view-resume:convert-to-niveus-format': ['StaffAugmentation', 'Resume Generation', 'Convert to Niveus Format'],
    'staff-augmentation:resume-generation:view-resume:edit-resume': ['StaffAugmentation', 'Resume Generation', 'Edit Resume'],
    'staff-augmentation:resume-generation:view-resume:download-resume': ['StaffAugmentation', 'Resume Generation', 'Download Resume'],
    'organization-contribution:tech-session:tech-session-calendar': ['OrganizationContribution', 'Tech Session', 'Calendar'],
    'organization-contribution:tech-session:tech-session-user': ['OrganizationContribution', 'Tech Session', 'Users'],
    'organization-contribution:tech-session:tech-session-receive-request': ['OrganizationContribution', 'Tech Session', 'Received Request'],
    'organization-contribution:blogs': ['OrganizationContribution', 'Blogs'],
    'resource:ai-access-request': ['Resource', 'AI Access Request'],
    'resource:ai-access-request-approval': ['Resource', 'AI Access Request Approval'],
    'resource:ai-access-request-dashboard': ['Resource', 'AI Access Request Dashboard'],
    'resource:ai-access-request-dashboard-summary': ['Resource', 'AI Access Request Dashboard Summary'],
};

const reorderFinanceMilestoneSection = (pageAccess) => {
    const financeMilestoneContent = pageAccess?.Finance?.content?.Milestone?.content;
    if (!financeMilestoneContent || !financeMilestoneContent['Milestone Section']) {
        return pageAccess;
    }

    const { ['Milestone Section']: milestoneSection, ...rest } = financeMilestoneContent;
    pageAccess.Finance.content.Milestone.content = {
        'Milestone Section': milestoneSection,
        ...rest,
    };

    return pageAccess;
};

export const usePermissionsData = (mainModule, permissionsOverride) => {
    let pageAccess = {};
    const modifyData = {
        View: 'read',
        Add: 'create',
        Edit: 'update',
        Delete: 'delete',
    };
    const viewEditData = {
        View: 'read',
        Edit: 'update',
    };
    const getModuleModifyData = (moduleKey) => {
        if (moduleKey === MODULE_NAMES.MIS_ROLE_RATIO_REPORT) {
            return viewEditData;
        }

        if (
            moduleKey === MODULE_NAMES.MIS_TIME_SHEET_LIST_VIEW
            || moduleKey === MODULE_NAMES.MIS_TIME_SHEET_CALENDAR_VIEW_EMPLOYEE_WISE
            || moduleKey === MODULE_NAMES.MIS_TIME_SHEET_CALENDAR_VIEW_ACTIVITY_WISE
        ) {
            return { View: modifyData.View };
        }

        if (moduleKey === MODULE_NAMES.HOME_DASHBOARD || moduleKey.startsWith(`${MODULE_NAMES.HOME_DASHBOARD}:`)) {
            return { View: modifyData.View };
        }

        if (moduleKey === MODULE_NAMES.DELIVERY_RESOURCE_LOADING_APPROVAL_HISTORY) {
            const { Add, ...approvalHistoryActions } = modifyData;
            return approvalHistoryActions;
        }

        if (moduleKey === MODULE_NAMES.MASTER_ALLOCATION_STAKE_HOLDERS) {
            const { Delete, ...actions } = modifyData;
            return actions;
        }

        return modifyData;
    };
    const { userProfile } = useContext(AuthContext);
    const permissions = permissionsOverride ?? userProfile?.permissions ?? {};

    Object.keys(permissions).forEach((key) => {
        if (permissionPathOverrides[key] === null) return;
        const moduleArray = splitColon(key);
        if (!Array.isArray(moduleArray) || moduleArray.length < 2) return;

        let formattedArray = permissionPathOverrides[key] || moduleArray.map(formatString);
        if (formattedArray[0] === 'MIS' && (formattedArray[1] === 'Finance Report' || formattedArray[1] === 'Finance') && formattedArray.length > 2) {
            formattedArray = ['MIS', ...formattedArray.slice(2)];
        }
        const actions = permissions[key];
        const moduleModifyData = getModuleModifyData(key);
        const setActions = Object.keys(moduleModifyData)
            .filter((actionKey) => actions.includes(moduleModifyData[actionKey]))
            .reduce((acc, actionKey) => {
                acc[actionKey] = moduleModifyData[actionKey];
                return acc;
            }, {});

        let current = pageAccess;
        formattedArray.forEach((mod, idx) => {
            if (typeof current !== 'object' || current === null) return;
            if (idx === formattedArray.length - 1) {
                if (!current[mod]) {
                    current[mod] = {
                        module: key,
                        actions: setActions,
                    };
                }
            } else {
                if (!current[mod]) {
                    current[mod] = {
                        title: mod,
                        active: false,
                        content: {},
                    };
                }
                current = current[mod].content;
            }
        });
    });

    const flattenMisFinanceReport = (accessObj) => {
        const misContent = accessObj?.MIS?.content;
        if (!misContent) return accessObj;

        ['Finance Report', 'Finance'].forEach((parentKey) => {
            if (misContent[parentKey]?.content) {
                const children = misContent[parentKey].content;
                delete misContent[parentKey];
                Object.assign(misContent, children);
            }
        });

        return accessObj;
    };

    reorderFinanceMilestoneSection(pageAccess);
    flattenMisFinanceReport(pageAccess);

    return { permissions, modifyData, pageAccess };
};

// Helper function for safe extraction of deep permissions
export function getPermission(pageAccess, keys) {
    let current = pageAccess;
    for (const key of keys) {
        if (!current || !current[key]) return undefined;
        current = current[key].content || current[key];
    }
    return current;
}
